import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent { }



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar/app-sidebar.component.ts